export default "__VITE_ASSET__3GNeNFoQ__"